/* eslint-disable i18next/no-literal-string */
import { useSyncExternalStore } from "react";
import { DiagnosticsEmpty } from "@/features/diagnostics/components/lib/diagnostics-card.tsx";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import { getDescriptionDisplayRows } from "@/features/diagnostics/utils/diff-smart-number-mapping.ts";
import { useAppSelector } from "@/redux/store.ts";
import { formatShortDate } from "@/utils/formatters.ts";
import { EventLogTime } from "../lib/event-log-item.tsx";

export default function SmartNumberList() {
    const mapping = useAppSelector((state) => state.smartNumber.mapping);
    const description = useAppSelector((state) => state.smartNumber.description);
    const calculatedResult = useAppSelector((state) => state.smartNumber.calculatedResult);
    const changes = useSyncExternalStore(DiagnosticsStore.subscribe, () => DiagnosticsStore.smartNumberChanges);

    if (!mapping || description.length === 0) {
        return <DiagnosticsEmpty>No smart number loaded yet!</DiagnosticsEmpty>;
    }

    const rows = getDescriptionDisplayRows(description, mapping);

    return (
        <div className="smart-number-diagnostics">
            <div className="smart-number-diagnostics__current">
                {calculatedResult && (
                    <div className="smart-number-diagnostics__result">{calculatedResult}</div>
                )}
                <table className="smart-number-diagnostics__table">
                    <thead>
                        <tr>
                            <th>Descriptor</th>
                            <th>Config code</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.index}>
                                <td>{row.descriptor}</td>
                                <td>{row.configCode}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="smart-number-diagnostics__changes">
                <h3 className="smart-number-diagnostics__changes-title">Changes</h3>
                {changes.length === 0 ? (
                    <DiagnosticsEmpty>No changes recorded yet!</DiagnosticsEmpty>
                ) : (
                    <ul className="smart-number-diagnostics__change-list">
                        {changes.map((entry) => (
                            <li key={entry.id} className="smart-number-diagnostics__change-entry">
                                <div className="smart-number-diagnostics__change-header">
                                    <EventLogTime>{formatShortDate(entry.timestamp)}</EventLogTime>
                                    <span className="smart-number-diagnostics__change-trigger">{entry.trigger}</span>
                                    <span className="smart-number-diagnostics__change-smart-number">
                                        {entry.smartNumberFrom || "—"} → {entry.smartNumberTo}
                                    </span>
                                </div>
                                <ul className="smart-number-diagnostics__field-changes">
                                    {entry.changes.map((change) => (
                                        <li key={change.descriptor} className="smart-number-diagnostics__field-change">
                                            <span className="smart-number-diagnostics__field-descriptor">
                                                {change.descriptor}
                                            </span>
                                            <span className="smart-number-diagnostics__field-values">
                                                {change.from || "—"} → {change.to || "—"}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
